const Highlighted = ({ text = "", highlightingArr = [], nightMode }) => {
  const union = highlightingArr.length
    ? `(${highlightingArr.map(el => `(?:${el.exp})`).join("|")})`
    : null;
  const splitRegex = union ? new RegExp(union, "gim") : null;
  let parts = null;

  if (highlightingArr.length > 0) {
    parts = text.split(splitRegex);
  }

  return (
    <p style={{ whiteSpace: "pre-wrap", padding: 10 }}>
      {parts ? (
        parts.map((part, i) => {
          const result = highlightingArr.find(el => {
            try {
              const reg = new RegExp(el.exp, "im");
              return reg.test(part);
            } catch (e) {
              console.error("RegExp error:", e);
              return false;
            }
          });
          if (result) {
            return (
              <span style={result?.style(part, text)} key={i}>
                {part}
              </span>
            );
          } else {
            return (
              <span key={i} style={{ color: nightMode ? "white" : "black" }}>
                {part}
              </span>
            );
          }
        })
      ) : (
        <span style={{ color: nightMode ? "white" : "black" }}>{text}</span>
      )}
    </p>
  );
};

export default Highlighted;
